
export function primaryColorModule(publisher_id) {
    try {
        if (publisher_id === 1) {
            return '#613EEA';
        } else if (publisher_id === 10) {
            return '#613EEA';
        } else if (publisher_id === 67) {
            return '#613EEA';
        } else if (publisher_id === 34) {
            return '#3AB65D';
        } else if (publisher_id === 68) {
            return '#00A3E0';
        } else if (publisher_id === 73) {
            return '#3AB65D';
        } else {
            return '#613EEA';
        }

    } catch (error) {
        console.error('Error primary color module:', error);
        return '#613EEA';
    }
}
